import { render, staticRenderFns } from "./IndexList06.vue?vue&type=template&id=6d23339e&scoped=true&"
import script from "./IndexList06.vue?vue&type=script&lang=js&"
export * from "./IndexList06.vue?vue&type=script&lang=js&"
import style0 from "./IndexList06.vue?vue&type=style&index=0&id=6d23339e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d23339e",
  null
  
)

export default component.exports